import React, { useState } from "react";
import Loginbutton from "../loginButton/loginbutton";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { GroupSelect } from "../dropDown/groupSelect";
import BusinessIcon from "@mui/icons-material/Business";

// CommonForm is a reusable form component used for login, registration, or similar forms
function CommonForm(formDatas) {
  const [eyeDefault, setEyeDefault] = useState(false); // toggle for password visibility
  const navigate = useNavigate();

  return (
    <div>
      {/* Back button for navigation */}
      <div
        className="back-icon"
        onClick={(e) => {
          navigate(formDatas?.backpath);
        }}
      >
        <ArrowBackIosOutlinedIcon />
        <p>Back</p>
      </div>

      {/* Form begins */}
      <form onSubmit={formDatas.onsubmit}>
        <h1 className="login-title">{formDatas?.title}</h1>
        <div className="underline"></div>

        {/* Dynamic input fields or dropdowns */}
        {formDatas?.inputGroups?.map((item) => (
          <>
            {/* Error handling */}
            {item?.error && item?.touched ? (
              <p className="password-alert">
                {item?.error === "Strong password required."
                  ? item?.error
                  : "This field is required"}
              </p>
            ) : (
              ""
            )}

            {/* Organization dropdown field */}
            {item?.fieldtype ? (
              <div style={{ margin: "40px 0px" }}>
                <GroupSelect
                  labelText={"Organization"}
                  labelIcon={<BusinessIcon />}
                  formLabel={""}
                  options={item?.orgData}
                  val={item?.organization}
                  handlechange={item?.handleChange}
                />
              </div>
            ) : (
              // Standard input field (with optional eye icon for password)
              <div
                className={
                  item.error && item.touched ? "input-group-red" : "input-group"
                }
              >
                <span className="icon">{item.icon}</span>

                <input
                  type={eyeDefault ? "password" : "text"}
                  placeholder={item.placeholder}
                  name={item.name}
                  className="input-field"
                  onChange={item.onChange}
                  value={item.value}
                />

                {/* Eye icon to toggle password visibility */}
                {item?.eyeicon === true ? (
                  <span
                    className="icon-eye"
                    onClick={() => setEyeDefault(!eyeDefault)}
                  >
                    {eyeDefault ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </span>
                ) : (
                  ""
                )}
              </div>
            )}
          </>
        ))}

        {/* Reusable login/submit button */}
        {Loginbutton({
          text: formDatas.btnText,
          onClick: formDatas.onClick,
          loader: formDatas?.loader,
        })}
      </form>
    </div>
  );
}

export default CommonForm;
